import directives from '../module';
import {animatronUpgrade, animatronPublish, animatronHtml5Offline, animatronProjectPreviewPicker} from 'lazy_modules';
import {BackendSvc} from '../../services/BackendSvc';
import {AuthenticationSvc} from '../../services/AuthenticationSvc';
import {TagsSvc} from '../../services/TagsSvc';
import {Utils} from 'underscore-extensions';
import {ProjectModalSvc} from '../../services/ProjectModalSvc';
import {HttpProjectSvc} from '../../services/HttpProjectSvc';
//import {AdminSvc} from '../../services/AdminSvc';

export interface ProjectPageParams extends ng.ui.IStateParamsService {
    project: anm.Project | undefined;
    projectId: string;
    staff?: string;
}

export class ProjectPageCtrl {
    animatronPublish = animatronPublish;
    animatronProjectPreviewPicker = animatronProjectPreviewPicker;
    animatronUpgrade = animatronUpgrade;
    animatronHtml5Offline = animatronHtml5Offline;

    projectDeferred: ng.IDeferred<anm.Project> = this.$q.defer();
    projectPromise: ng.IPromise<anm.Project> = this.projectDeferred.promise;
    projectSizes: Array<number>;
    sizes: {projectSize: number};
    /** created in projectPageCanvasDirective */
    player: ng.IPromise<Player | null> = this.$q.resolve(null);
    toggleFullscreen: Function;
    project: anm.Project;
    editTagsMode = false;

    twoPlayers = this.$location.search().twoPlayers;

    constructor(public $scope: any,
                private $rootScope: ng.IRootScopeService,
                private $timeout: ng.ITimeoutService,
                private $http: ng.IHttpService,
                private $stateParams: ProjectPageParams,
                private $state: ng.ui.IStateService,
                private $location: ng.ILocationService,
                private $filter: ng.IFilterService,
                private TagsSvc: TagsSvc,
                private AdminSvc: any,
                private httpProjectSvc: HttpProjectSvc,
                private ProjectAugmenter: any,
                // private upgradeOneProjectSvc: UpgradeOneProjectSvc,
                private ProjectModalSvc: ProjectModalSvc,
                private BackendSvc: BackendSvc,
                private AuthenticationSvc: AuthenticationSvc,
                private $q: ng.IQService) {
        const destroy = $scope.$watch(() => this.$stateParams.projectId, (id: string) => {
            if (id) {
                this.init();
                destroy();
            }
        });
    }

    init() {
        this.$scope.projectExist = true;
        this.$scope.busy = true;
        this.$scope.staffUrl = this.$stateParams.staff;
        this.$scope.staffButtons = options.user.staff || this.$stateParams.staff;
        this.$scope.isProduction = options.isProduction;
        this.$scope.authSvc = this.AuthenticationSvc;
        this.$rootScope.$watch('user', user => this.$scope.user = user);

        const headers = {};
        if (options.user.hash.length > 0) {
            headers['Animatron-Security-Token'] = options.user.hash;
        }

        this.$scope.tagPattern = options.user.staff ? '^[!0-9a-zA-Z _\'"-]+$' : '^[0-9a-zA-Z가-힣 _\'"-]+$';

        const handleProject = (project: anm.Project) => {
            this.$scope.projectLoaded = true;
            this.$scope.busy = false;
            if (!project || Utils.isApiError(project)) {
                this.$scope.errorMsg = 'The requested project has not been found.';
                this.$rootScope.wrapperClass += ' wrapper-not-found';
                this.$scope.projectExist = false;
                this.projectDeferred.reject(project);
                document.head.querySelector('[name=robots]').content = 'noindex';
                document.head.querySelector('[name=prerender-status-code]').content = '404';
                return;
            }
            this.$rootScope.setTitle('project.title', project.name);
            this.ProjectAugmenter(project);
            this.project = this.$scope.project = project;
            this.projectDeferred.resolve(project);

            const rolez = options.user.subscriptionDetails.studio.features.rolez;
            this.$scope.canEditTags = project.isOwner || (rolez.Admin && rolez.Admin.canCreateSuperTags);
            if (this.$scope.canEditTags) {
                this.$scope.tagsSvc = this.TagsSvc;
            }

            const minWidth = 640;
            this.projectSizes = _.chain([320, 640, 720, 1080, 1650, 1920, 2048, project.width])
                .uniq()
                .sortBy()
                .value();
            this.sizes = {projectSize: this.$location.search().width || this.$location.search().w || Math.max(project.width, minWidth)};

            this.$scope.adminSvc = new this.AdminSvc(this.$scope.project);
        };

        const projId = this.$stateParams.projectId;
        const findProj = () => {
            if (options.project && options.project.id === projId) {
                return options.project;
            }
            return this.$stateParams.project; //nullable
        };
        const foundProject = findProj();
        if (foundProject) {
            this.$scope.$watch(() => this.project, (p: anm.Project) => _.extend(this.$stateParams.project, p), true);
            handleProject(foundProject);
        }
        if (!foundProject || !foundProject.author) {
            const url = options.apiDomain + '/project/' + projId;
            this.$http.get<anm.Project>(url, {headers})
                .then(r => handleProject(r.data))
                .catch(handleProject);
        }

        this.$scope.showAddTagsBtn = () => this.$scope.canEditTags && !this.editTagsMode && _.isEmpty(this.$scope.project.tags);

        this.$scope.toggleEditMode = () => {
            this.$timeout(() => {
                if (this.$scope.canEditTags) {
                    this.editTagsMode = !this.editTagsMode;
                    setTimeout(() => {
                        const tagsInput = document.querySelector('.tags input');
                        if (this.editTagsMode && tagsInput) {
                            tagsInput.focus();
                        }
                    }, 0);
                }
            });
        };

        this.$scope.removeProject = () => this.$timeout(() => {
            this.httpProjectSvc
                .removeProject(this.$scope.project.id)
                .then(() => {
                    if (this.ProjectModalSvc.projectModalShown) {
                        window.history.back();
                    } else {
                        this.$state.go('home');
                    }
                });
        });

        const updateRequest = (field: string, newVal: string) =>
            this.BackendSvc.getServerUrl(this.$scope.project).then(serverUrl => {
                const data = {[field]: newVal};
                const u = serverUrl + `/project/update/meta/${this.$scope.project.id}`;
                return this.$http.put(u, data, {headers});
            });

        const setupFieldWatch = (field: string, callback?: Function) => {
            this.$scope.$watch(`project.${field}`, (newVal?: string , old?: string) => {
                if (_.isUndefined(newVal)) return;
                const sanitized = this.$filter('stripTags')(newVal);
                if (newVal === old || sanitized === old || _.isUndefined(old)) return;
                updateRequest(field, sanitized);
                if (callback) callback(sanitized);
            });
        };

        setupFieldWatch('description');
        setupFieldWatch('name', (val?: string) => {
            const projSelector = document.getElementById(this.$scope.project.id);
            if (projSelector) {
                const nameSelector = angular.element(projSelector.querySelector('.project-name'));
                nameSelector.html(val);
                nameSelector.attr('title', val);
            }
        });
    }

    // TODO refactor, shown is not used, passing foreign scope is a sign of a bad design
    // public upgradeShown = (foreignScope: any, shown: boolean) => {
    //     foreignScope.upgrade = {
    //         project: true,
    //         currentPrice: 500,
    //         monthPrice: 500,
    //         yearPrice: 2000,
    //         foreverPrice: 5000,
    //         projectId: this.$scope.project.id
    //     };
    //     foreignScope.upgradeModal = {chosen: true};
    // };
    //
    // setUpgradeProject(project: anm.Project) {
    //     this.upgradeOneProjectSvc.setUpgradeProject(project);
    // }

    restore() {
        this.$http.get(options.apiDomain + '/project/undelete/' + this.$scope.project.id, {headers: options.headers})
            .then(() => {
                _.notification.showSuccess(this.$rootScope.t('project.restore.success'));
            });
    }
}

directives.component('projectPage', {
    controllerAs: 'ProjectPageCtrl',
    controller: ProjectPageCtrl,
    templateUrl: require('project/project.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/project/ProjectPage.ts